"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCache = void 0;
/**
 * Storage for static keys of previously connected peers.
 */
class Keycache {
    constructor() {
        this.storage = new Map();
    }
    store(peerId, key) {
        this.storage.set(peerId.id, key);
    }
    load(peerId) {
        if (!peerId) {
            return null;
        }
        return this.storage.get(peerId.id) || null;
    }
    resetStorage() {
        this.storage.clear();
    }
}
const KeyCache = new Keycache();
exports.KeyCache = KeyCache;
//# sourceMappingURL=keycache.js.map